import { encodeQueryParams } from '~/utils'

export const state = () => ({
  emailListOptions: [],
  emailTemplateOptions: [],
})

export const actions = {
  async loadEmailTemplateOptions({ commit }, { search, customerId }) {
    const params = {
      search,
      customerId,
    }
    const query = encodeQueryParams(params)

    const { data } = await this.$axios.get(
      `transaction-mails/templates?${query}`
    )
    commit('setEmailTemplateOptions', data.data)
  },

  async sendMail({ commit }, { templateId, mailForm }) {
    const { data } = await this.$axios.post(
      `transaction-mails/templates/${templateId}/send`,
      mailForm,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )

    return data
  },

  async updateTemplate({ commit }, { templateId, customerId, subject, body }) {
    const { data } = await this.$axios.patch(
      `admin/transaction-mails/templates/${templateId}`,
      {
        subject,
        body,
        customer_id: customerId,
      }
    )
    commit('updateEmailTemplateOption', data.data)

    return data.data
  },
}

export const mutations = {
  setEmailTemplateOptions(store, templates) {
    store.emailTemplateOptions = templates
  },

  updateEmailTemplateOption(store, template) {
    store.emailTemplateOptions = store.emailTemplateOptions.map((option) =>
      option.id === template.id ? template : option
    )
  },
}

export const getters = {
  emailTemplateOptions(state) {
    return state.emailTemplateOptions.map((template) => ({
      name: template.name,
      value: template.id,
      body: template.body,
      subject: template.subject,
      attachments: template.attachments,
    }))
  },
}
